// extracted by mini-css-extract-plugin
export default {"melodyVideo":"lO-z","isFullWidth":"mO-z","landingPageVideo":"nO-z","play":"oO-z","iframeVideo":"pO-z","playHidden":"qO-z","fullwidth":"rO-z"};